module.exports = __webpack_public_path__ + "static/media/error.39f1b497.svg";